module.exports = __webpack_public_path__ + "img-front/register/kinesis-five.d02a72ac.svg";